export * from "@/ui/components/data-display/Collapsible/Collapsible";
export * from "@/ui/components/data-display/Collapsible/Collapsible.config";
export * from "@/ui/components/data-display/Collapsible/CollapsibleContent";
export * from "@/ui/components/data-display/Collapsible/CollapsibleRoot";
export * from "@/ui/components/data-display/Collapsible/CollapsibleTrigger";
